module.exports = __webpack_public_path__ + "img/qpay.11d5db6c.jpeg";